export const includesForbiddenCharacters = (input)=>{
    const pattern = /[, :;[\]<>]/;
    return pattern.test(input);
};
export const filterOptions = (options, inputValue)=>{
    if (inputValue === '') {
        return [];
    } else if (!inputValue.includes('@')) {
        return options;
    } else {
        return options.filter((option)=>{
            const emailDomain = `@${inputValue.split('@')[1]}`;
            return option.startsWith(emailDomain) && option !== emailDomain;
        });
    }
};
export const shouldOpenDropdown = (options, inputValue)=>filterOptions(options, inputValue).length >= 1;
export const constructEmailAddress = (fieldValue, suggestionValue)=>{
    const beforeAt = fieldValue.split('@')[0];
    return `${beforeAt}${suggestionValue}`;
};
